export default __webpack_public_path__ + "static/media/counter.56e4a99c.svg";